import { useState } from "react";
import { Loader2, MailCheck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { SimpleAuthShell, primaryBtn } from "@/components/SimpleAuthShell";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <SimpleAuthShell title="Mot de passe oublié">
      {sent ? (
        <div className="rounded-2xl bg-emerald-50 border-2 border-emerald-300 p-5 flex gap-3" data-testid="forgot-success">
          <MailCheck className="w-7 h-7 text-emerald-700 shrink-0" />
          <p className="text-emerald-900">Si un compte existe pour <b>{email}</b>, vous allez recevoir un lien par email (valable 1 heure).</p>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-5" data-testid="forgot-form">
          <p className="text-slate-600">Entrez votre email. Nous vous envoyons un lien pour choisir un nouveau mot de passe.</p>
          <div className="space-y-2">
            <Label htmlFor="femail">Email</Label>
            <Input id="femail" type="email" required className="h-12 text-base" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input" />
          </div>
          <button type="submit" disabled={busy} className={primaryBtn} data-testid="forgot-submit-btn">
            {busy && <Loader2 className="w-5 h-5 animate-spin" />} Envoyer le lien
          </button>
        </form>
      )}
    </SimpleAuthShell>
  );
}
